import Aos from 'aos';
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

function WhatWe() {
  const navigate = useNavigate();
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation speed
      once: true,     // run only once
      easing: "ease-out",
    });
  }, []);
  return (
    <>

      <section className="relative overflow-hidden mt-[66px] lg:mt-[72px]">
        <img
          src="/assets/home/sig.jpg"
          alt="Background"
          className="h-[300px] md:h-[363px] w-full object-cover"
        />

        <div className="absolute inset-0 flex items-center justify-start">
          <div className="max-w-[1440px] mx-auto w-full px-[20px] lg:px-[70px]">
            <div>
              <h6
                data-aos="fade-up"
                data-aos-delay="150"
                className=" pb-[0px] font-neue font-[400] text-[28px] md:text-[36px] leading-[40px] md:leading-[52px] text-[#ffff] text-left mt-[10px]"
              >What We Do
              </h6>

              <h6
                data-aos="fade-up"
                data-aos-delay="400"
                className="pt-[2px] pb-[8px] font-neue font-[400] text-white text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] leading-[30px] sm:leading-[38px] md:leading-[46px] lg:leading-[52px]"
              >
                For companies and investors doing business between the United States and India.
              </h6>
            </div>
          </div>
        </div>
      </section>
      <br />
      <br />
      {/* <div className='whatwedo-boxs lg:px-[70px] px-[20px] max-w-[1440px] mx-auto' >

        <div class="whatwedo-box  whatwedo-box5 ">
          <div class="whatwedo-box-overlay">
            <h3>Strategic Matchmaking</h3>
            <p>
              We curate relationships across founders, funds, decisionmakers, and primes — aligning only when there’s deep strategic fit.
              Every introduction is intentional. Every pairing, high-trust. Every deal, mission-oriented.
            </p>
          </div>
        </div>

        <div class="whatwedo-box whatwedo-box2 whatwedo-box5">
          <div class="whatwedo-box-overlay">
            <h3>Corridor Design</h3>
            <p>
              We help build cross-border pathways — from market entry and licensing to dual-use structuring — using the frameworks that already exist.
              While we help shape new rules, we activate the ones that work.
            </p>
          </div>
        </div>

        <div class="whatwedo-box whatwedo-box3 whatwedo-box5">
          <div class="whatwedo-box-overlay">
            <h3>Narrative & Presence</h3>
            <p>
              We shape strategic visibility. That includes placing the right stories in the right rooms.
              Not just attention — position.

            </p>
          </div>
        </div>
        <div class="whatwedo-box whatwedo-box4 whatwedo-box5">
          <div class="whatwedo-box-overlay">
            <h3>Execution (via Partners)</h3>
            <p>
              Through trusted collaborators, we structure capital, navigate complexity, and drive business outcomes.

              We engage selectively — sometimes through retainers, sometimes through equity, sometimes through outcomes.

            </p>
          </div>
        </div>


      </div> */}

      {/* <div className='lg:px-[70px] px-[20px] max-w-[1440px] mx-auto pt-[60px] sm:pt-[80px] lg:pt-[100px] pb-[60px] sm:pb-[80px] lg:pb-[100px]' >
        <p
          data-aos="fade-up"
          data-aos-delay="400"
          className="font-neue font-[400] sm:font-[500] text-black text-[16px] sm:text-[18px] md:text-[20px] leading-[24px] sm:leading-[28px] md:leading-[25px] tracking-[-0.22px]"
        >
          Success in U.S.–India defense rarely comes down to a single thing. It depends on how a company is structured, how it clears regulatory review, how its partnerships are built, and how it is understood by the people who matter. We work across all of it, in both directions, and stay with a company from its first entry through its long-term representation. We also advise institutions on program design and policy analysis on U.S.–India questions.
        </p>
      </div> */}
      <div className='lg:px-[70px] px-[20px] max-w-[1440px] mx-auto pt-[10px] sm:pt-[20px] lg:pt-[40px] pb-[10px] sm:pb-[20px] lg:pb-[40px]' >

        <h6
          data-aos="fade-up"
          data-aos-delay="150"
          className=" pb-[0px] font-neue font-[400] text-[20px] md:text-[24px] leading-[24px] md:leading-[28px] text-[#0F3460] text-left"
        >
          Cross-border success in this sector depends on how a company is structured, how it clears regulatory review, how it builds partnerships, and how it positions itself in the market. We advise on each of these, in both directions. We work with Indian companies building a presence in the United States and with U.S. companies entering India. For investors, we assess opportunities across the corridor, including the commercial and regulatory factors that determine whether a company can compete in either market.
        </h6>
      </div>
      <div className='lg:px-[70px] px-[20px] max-w-[1440px] mx-auto pt-[60px] sm:pt-[80px] lg:pt-[100px] pb-[60px] sm:pb-[80px] lg:pb-[100px]' >
        <div className='new-wedo-boxs'>
          <div className='new-wedo-box'>
            {/* <img src='./assets/home/s1.jpg' alt='' /> */}
            <img src='./assets/home/defence1.jpeg' alt='' />
            <div className='new-wedo-box-text'>
              <h3>
                Market entry and structure
              </h3>
              <p>
                We advise companies on how to enter a new market and how to structure the business. That includes the entity, its ownership and governance, the capital structure, and the approvals required. Once a company is operating, we remain its advisor as the business grows and its priorities change.
              </p>
            </div>
          </div>
          <div className='new-wedo-box'>
            {/* <img src='./assets/home/s2.jpg' alt='' /> */}
            <img src='./assets/home/defence2.jpeg' alt='' />
            <div className='new-wedo-box-text'>
              <h3>
                Regulatory strategy
              </h3>
              <p>
                ITAR and other export controls, CFIUS, foreign-ownership limits, industrial licensing, DAP, and SCOMET define what is possible in this sector. We address these questions before a deal takes shape, so the structure holds up under review. We also conduct diligence on the counterparties our clients are considering, working closely with specialist counsel.
              </p>
            </div>
          </div>
          <div className='new-wedo-box'>
            {/* <img src='./assets/home/s3.jpg' alt='' /> */}
            <img src='./assets/home/defence3.jpeg' alt='' />
            <div className='new-wedo-box-text'>
              <h3>
                Commercial and partnership strategy
              </h3>
              <p>
                We help companies determine where their product fits, who the buyer is, which partnership model will make them competitive, and when to move. We also build the commercial case that lenders and investors need to see, grounded in real demand and a credible path to revenue.
              </p>
            </div>
          </div>
          <div className='new-wedo-box'>
            {/* <img src='./assets/home/2151917417.jpg' alt='' /> */}
            <img src='./assets/home/defence4.jpeg' alt='' />
            <div className='new-wedo-box-text'>
              <h3>
                Sector intelligence
              </h3>
              <p> 
                We track deals, procurement, and policy across both markets every week and apply that work to each client's position. Clients see shifts in the market early and act on them first. DOT Weekly, our public brief, draws on this tracking and reaches a senior audience in both countries.
              </p>
            </div>
          </div>




        </div>
      </div>
      <br />
      <br />

      {/* <section className='lg:pt-[102px] pt-[40px] pb-[50px] lg:px-[70px] px-[20px]' style={{ background: "linear-gradient(180deg, rgba(15, 52, 96, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)" }}>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[118px] px-[0px]">
                    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-[50px] gap-[20px]">
                        <div className='bg-[#FFFFFF] rounded-[30px] lg:px-[28px] px-[16px] py-[30px]' style={{ boxShadow: "0px 4px 54px 0px #BB872A33" }}>
                            <div className='relative'>
                                <img src="/assets/home/s1.jpg" className='h-[432px] object-cover rounded-[20px]' alt="" />
                                <div className="absolute inset-0 bg-[#001E42]/80 rounded-[20px]"></div>
                                <div className="flex flex-col items-center w-full pt-[30px] top-0 pb-[16px] absolute">
                                    <img src="/assets/home/icon1.svg" alt="" />
                                    <h6 className="pt-[30px] pb-[23px]  font-neue font-[400] text-[24px] leading-[20px] tracking-[-0.16px] text-[#FFFFFF] w-full text-center">
                                        Strategic Matchmaking
                                    </h6>
                                    <p className="pt-[23px] px-[30px] font-[400] font-neue text-[14px] leading-[22px] tracking-[-0.22px] text-center text-[#CACBD4] pb-[37px]">We curate relationships across founders, funds, decisionmakers, and primes — aligning only when there’s deep strategic fit. Every introduction is intentional. Every pairing, high-trust. Every deal, mission-oriented.</p>
                                    <img src="/assets/home/arrow.svg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className='bg-[#FFFFFF] rounded-[30px] lg:px-[28px] px-[16px] py-[30px]' style={{ boxShadow: "0px 4px 54px 0px #BB872A33" }}>
                            <div className='relative'>
                                <img src="/assets/home/s2.jpg" className='w-full h-[432px] object-cover rounded-[20px]' alt="" />
                                <div className="absolute inset-0 bg-[#001E42]/80 rounded-[20px]"></div>
                                <div className="flex flex-col items-center w-full pt-[30px] top-0 pb-[16px] absolute">
                                    <img src="/assets/home/icon2.svg" alt="" />
                                    <h6 className="pt-[30px] pb-[23px]  font-neue font-[400] text-[24px] leading-[20px] tracking-[-0.16px] text-[#FFFFFF] w-full text-center">
                                        Narrative & Presence
                                    </h6>
                                    <p className="pt-[23px] px-[30px] font-[400] font-neue text-[14px] leading-[22px] tracking-[-0.22px] text-center text-[#CACBD4] pb-[15px]">We shape strategic visibility. That includes placing the right stories in the right rooms. Not just attention — position.
                                        We don’t do public panels, roundtables, or open events. When we convene, it’s behind closed doors — saloons, not stages.</p>
                                    <img src="/assets/home/arrow.svg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className='bg-[#FFFFFF] rounded-[30px] lg:px-[28px] px-[16px] py-[30px]' style={{ boxShadow: "0px 4px 54px 0px #BB872A33" }}>
                            <div className='relative'>
                                <img src="/assets/home/s3.jpg" className='h-[432px] object-cover rounded-[20px]' alt="" />
                                <div className="absolute inset-0 bg-[#001E42]/80 rounded-[20px]"></div>
                                <div className="flex flex-col items-center w-full pt-[30px] top-0 pb-[16px] absolute">
                                    <img src="/assets/home/icon3.svg" alt="" />
                                    <h6 className="pt-[30px] pb-[23px]  font-neue font-[400] text-[24px] leading-[20px] tracking-[-0.16px] text-[#FFFFFF] w-full text-center">
                                        Corridor Design
                                    </h6>
                                    <p className="pt-[23px] px-[30px] font-[400] font-neue text-[14px] leading-[22px] tracking-[-0.22px] text-center text-[#CACBD4] pb-[37px]">We help build cross-border pathways — from market entry and licensing to dual-use structuring — using the frameworks that already exist. While we help shape new rules, we activate the ones that work.</p>
                                    <img src="/assets/home/arrow.svg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className='bg-[#FFFFFF] rounded-[30px] lg:px-[28px] px-[16px] py-[30px]' style={{ boxShadow: "0px 4px 54px 0px #BB872A33" }}>
                            <div className='relative'>
                                <img src="/assets/home/s4.jpg" className='h-[432px] object-cover rounded-[20px]' alt="" />
                                <div className="absolute inset-0 bg-[#001E42]/80 rounded-[20px]"></div>
                                <div className="flex flex-col items-center w-full pt-[30px] top-0 pb-[16px] absolute">
                                    <img src="/assets/home/icon4.svg" alt="" />
                                    <h6 className="pt-[30px] pb-[23px] font-neue font-[400] text-[24px] leading-[20px] tracking-[-0.16px] text-[#FFFFFF] w-full text-center">
                                        Execution (via Partners)
                                    </h6>
                                    <p className="pt-[23px] px-[30px] font-[400] font-neue text-[14px] leading-[22px] tracking-[-0.22px] text-center text-[#CACBD4] pb-[37px]">Through trusted collaborators, we structure capital, navigate complexity, and drive business outcomes. <br />We engage selectively — sometimes through retainers, sometimes through equity, sometimes through outcomes.</p>
                                    <img src="/assets/home/arrow.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
      {/* <section className="relative">
                <img
                    src="/assets/what/bg2.png"
                    className="h-[300px] sm:h-[400px] md:h-[500px] lg:h-[539px] w-full object-cover"
                    alt="Corridor Background"
                />
                <div className="absolute inset-0 bg-[#001E42]/80 rounded-none md:rounded-[20px]"></div>
                <div className="absolute z-10 lg:top-1/2 top-[100px] left-1/2 -translate-x-1/2 -translate-y-1/2 w-full px-4 flex flex-col items-center text-center">
                    <h6 className=" text-center pb-[10px] sm:pb-[12px] md:pb-[15px] font-neue font-[400] text-[20px] sm:text-[26px] md:text-[32px] lg:text-[36px] leading-[30px] sm:leading-[38px] md:leading-[46px] lg:leading-[52px] text-white max-w-[90%]">
                        We’re not a marketplace.{" "}
                        <span className="text-[#fff] italic"> We’re a corridor.</span>
                    </h6>
                    <p className="font-[400] font-neue text-[14px] sm:text-[15px] md:text-[16px] leading-[22px] sm:leading-[26px] md:leading-[30px] tracking-[-0.22px] text-center text-white pb-[20px] sm:pb-[25px] md:pb-[33px]">
                        If you think we’re aligned
                    </p>
                    <button
                        style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                        className="py-[10px] sm:py-[12px] px-[14px] sm:px-[15px] transition-all duration-500 
                 hover:bg-white hover:text-[#BB872A] border hover:border-[#BB872A] 
                 border-white bg-[#BB872A] rounded-[8px] sm:rounded-[12px] 
                 font-[400] font-neue text-[13px] sm:text-[14px] leading-[20px] 
                 text-center text-white"
                    >
                        Get In Touch
                    </button>
                </div>
            </section> */}
      <div
        className="the-corridor-div the-corridor-div2 bg-[#0F3460] py-[50px]"
        data-aos="fade-in"
        data-aos-duration="1000"
      >
        <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[70px] text-left">
          <h6
            data-aos="fade-up"
            data-aos-delay="200"
            className="pb-[16px] font-neue font-[400] text-[26px] sm:text-[32px] md:text-[36px] leading-[34px] sm:leading-[40px] md:leading-[44px] text-white"
          >
            Ask us about our work. <br />
          </h6>
          <p
            data-aos="fade-up"
            data-aos-delay="350"
            className="font-neue font-[400] text-[15px] sm:text-[16px] leading-[22px] sm:leading-[26px] tracking-[-0.22px] text-white/90 pb-[28px]"
          >
          We keep client engagements confidential and are glad to discuss relevant experience with prospective clients.
          </p>
          <button
            onClick={() => { navigate('/contact-us') }}
            data-aos="zoom-in"
            data-aos-delay="500"
            className="py-[12px] px-[22px] rounded-[12px] font-neue font-[400] text-[14px] leading-[20px]
        bg-[#BB872A] text-white border border-[#FFFFFF] transition-all duration-500
        hover:bg-white hover:text-[#BB872A] hover:border-[#BB872A] shadow-[inset_0px_2px_16px_1px_#FFFFFFB5]"
          >
            Get in touch
          </button>

        </div>
      </div>



    </>
  )
}

export default WhatWe
